<template>
	<div
		class="col-12 d-md-flex flex-md-row mb-3 mb-md-0 pe-0 pe-md-3 py-0 py-md-4 ps-0"
	>
		<div
			@click.stop="$emit('setViewDetailClicked')"
			class="cursor-pointer pe-4 d-flex flex-row d-md-flex flex-md-column my-1"
		>
			<div
				class="heading text-primary-blue d-flex flex-row nowrap align-items-center"
			>
				<span class="me-2">{{fomattedRatingByLocale }}/5</span>
				<svg class="icon" width="16" height="16">
					<use href="#___icon___customer-reviews"></use>
				</svg>
			</div>
			<div class="d-md-none me-3"></div>
			<div class="text-nowrap d-flex align-items-center">
				<button class="see-details-btn link-small p-0">
					{{ content.liheReviews_seeDetail }}
				</button>
			</div>
		</div>

		<div class="d-none d-md-flex border-primary-blue me-4"></div>

		<div class="d-flex col-12 col-lg-7 p-0">
			<Summary :ratings="ratings" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Summary from "../common/summary.vue";

export default {
	name: "SummaryRow",
	props: {
		globalRating: {
			type: Number,
			default: 5,
		},
		ratings: {
			// array of object, each having the name as key and number as value
			type: [],
			default: () => {
				return [];
			},
		},
	},
	components: {
		Summary,
	},
	computed: {
		...mapState(["content", "language"]),
		starsArr() {
			return this.ratings
				.map((ratingObj) => {
					const name = ratingObj["name"];
					const rating = ratingObj["rating"];

					return {
						name,
						readableName: this.content[`reviews_ratingTypes_${name}`],
						stars: this.getStarsObj(rating),
					};
				})
				.filter((_) => _);
		},
		fomattedRatingByLocale() {
			const formattedGlobalRating = this.globalRating
				.toFixed(1)
				.replace(/\.0$/, "");

			if (this.language === "fr-FR" || this.language === "fr-FR-CSE") {
				return formattedGlobalRating.replace(".", ",");
			} else {
				return formattedGlobalRating;
			}
		},
	},
	methods: {
		getStarsObj(ratingFloat) {
			const full = Math.trunc(ratingFloat);
			const decimalPart = ratingFloat - full;
			const half = decimalPart > 0.33 && decimalPart < 0.67 ? 1 : 0;
			const empty = 5 - full - half;
			return { full, half, empty };
		},
	},

	
};
</script>

<style scoped>
.see-details-btn {
	background: none;
	border: none;
	outline: none;
}
</style>
